import styled from 'styled-components'

export default styled.p`
    font-size: 16px;
    line-height: 24px;
    font-weight: bolder;
`